/**
 * Neutral examples quoted in hints and fix messages. Never a tenant's or a demo's values.
 * The address examples match magic-core's EXAMPLE_* (schemas/distribution/recipients.py), so a
 * row's fix message reads the same whether the browser or the server checked it.
 */
export const EXAMPLE_EMAIL = "name@company.com";
export const EXAMPLE_CC = "first@company.com; second@company.com";
export const EXAMPLE_SLACK_CHANNEL = "#channel-name";
export const EXAMPLE_TEAMS_CHANNEL = "Team › Channel";
export const EXAMPLE_LOGO_URL = "https://company.com/logo.png";
export const EXAMPLE_ACCENT = "#0F7B6C";
